import footerhtml from "./footer_template";

export default (settings) => {
    
    const footercontainer = document.getElementById("site_footer");
    
    
    footercontainer.innerHTML = footerhtml();
    
}